import { featureFlags } from "#/config/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

export const useRealtimeLastTradesFeatureFlag = () => {
  const isRealtimeLastTradesEnabled =
    useFeatureFlags<boolean>(featureFlags.realtimeLastTrades) ?? false;

  return { isRealtimeLastTradesEnabled };
};
